export default __webpack_public_path__ + "static/media/backbutton.029c05fe.svg";